import React from 'react';
import styled from 'styled-components';
import Divider from '@material-ui/core/Divider';
import { useTable, useSortBy, usePagination, useBlockLayout } from 'react-table';
import CircularProgress from '@material-ui/core/CircularProgress';
import TablePagination from '@material-ui/core/TablePagination';
import { useSticky } from "react-table-sticky";
import { Styles } from './TableVisitRouteStickyStyles'; 
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSort, faCaretUp, faCaretDown } from '@fortawesome/free-solid-svg-icons'
import { numberFormat } from '../../utils/NumberFormat';
import { useSelector } from 'react-redux';
import { translator } from '../../utils/Translator';

const Loading2 = () => {
    const { translate } = useSelector(({i18n}) => i18n);
    return (
        <div
            className="overlay"
            style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 9999, // Ensure the loader is on top
            }}
        >
            <CircularProgress />
            <h5 className="mt-2">{translator(translate.ISA_Loading, "กำลังโหลดข้อมูล")}</h5>
        </div>
    );
};

const TableVisitRouteSticky = ({
    columns,
    data,
    loading,
    initialSortBy,
    initialPageSize,
    pageCount: controlledPageCount,
    getRowProps = () => ({})
}) => {
    const { translate } = useSelector(({i18n}) => i18n);

    // Use the state and functions returned from useTable to build your UI
    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        footerGroups,
        rows,
        prepareRow,
        page,
        canPreviousPage,
        canNextPage,
        pageOptions,
        pageCount,
        gotoPage,
        nextPage,
        previousPage,
        setPageSize,
        state: { sortBy, pageIndex, pageSize },
    } = useTable({
        columns,
        data,
        initialState: {
            sortBy: initialSortBy ? initialSortBy : [],
            pageIndex: 0,
            pageSize: initialPageSize ? initialPageSize : 10
        },
    },
    useSortBy,
    usePagination,
    useBlockLayout,
    useSticky)

    const handleChangePage = (event, newPage) => {
        if(newPage > pageIndex){
            nextPage();
        }else{
            previousPage()
        }
    };

    const handleChangeRowsPerPage = (event) => {
        setPageSize(Number(event.target.value))
        gotoPage(0)
    };

    let maxHeight = 2700;

    return (
        <Styles>
            <div
                {...getTableProps()}
                className="table sticky"
                style={{ width: '100%', maxHeight: maxHeight }}
            >
                <div className="header">
                    {headerGroups.map(headerGroup => (
                        <div {...headerGroup.getHeaderGroupProps()} className="tr">
                        {headerGroup.headers.map(column => (
                            <div {...column.getHeaderProps(column.getSortByToggleProps())} className="th">
                                <div className="d-flex">
                                    <div className="w-100">
                                        {column.render('Header')}
                                    </div>
                                    {column.isSorted
                                        ? column.isSortedDesc
                                            ? <div className="flex-shrink-1 pl-1"><FontAwesomeIcon icon={faCaretDown} /></div>
                                            : <div className="flex-shrink-1 pl-1"><FontAwesomeIcon icon={faCaretUp} /></div>
                                        : ''}
                                    
                                </div>
                            </div>
                        ))}
                        </div>
                    ))}
                </div>

                <div {...getTableBodyProps()} className="body">
                    { loading 
                        ? 
                        <div className="tr">
                            <div className="td">
                                <Loading2 />
                            </div>
                        </div>
                        :
                        page.map((row, i) => {
                            prepareRow(row);
                            return (
                                <div {...row.getRowProps(getRowProps(row))} className="tr">
                                    {row.cells.map(cell => {
                                    return (
                                        <div {...cell.getCellProps()} className="td" >
                                            {cell.render("Cell")}
                                        </div>
                                    );
                                    })}
                                </div>
                            );
                        })
                    }
                    
                </div>
            </div>
            

            <TablePagination
                rowsPerPageOptions={[10, 20, 30, 40, 50, 100]}
                component="div"
                count={parseInt(data.length)}
                rowsPerPage={pageSize}
                page={pageIndex}
                onChangePage={handleChangePage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
                labelRowsPerPage={translator(translate.ISA_RowsPerPage, "แถวต่อหน้า:")}
                labelDisplayedRows={({ from, to, count }) => `${from}–${to} ${translator(translate.ISA_Of, "จาก")} ${count !== -1 ? numberFormat(count, 0) : `${translator(translate.ISA_MoreThan, "มากกว่า")} ${to}`}`}
            />
        </Styles>
    )
}

export default TableVisitRouteSticky;